import React from 'react'

import {
  Box,
  Grid,
  Typography,
} from '@mui/material'

const LandingWhy = (props) => {
  return (
    <Grid container spacing={2} p={4} py={8} sx={{ bgcolor: 'white' }}>
      <Grid item xs={12} pb={2}>
        <Typography align='center' color='primary' variant='h3' gutterBottom>
          <b style={{ fontWeight: 900 }}>¿Por qué LightSpot?</b>
        </Typography>
        <Typography align='center' color='#00c08b' variant='h5' gutterBottom>
          <b style={{ fontWeight: 700 }}>Formando equipos de trabajo académico integrales</b>
        </Typography>
      </Grid>
      <Grid item xs={12} md align='center'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              component='img'
              src='/assets/images/circle-innovation.png'
              sx= {{ width: '40%' }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography align='center' color='primary' variant='h6' gutterBottom>
              <b style={{ fontWeight: 900 }}>Innovación</b>
            </Typography>
            <Typography align='center' variant='body1' gutterBottom>
              Es la primera aplicación que busca fortalecer la preceptoría a través de herramientas digitales.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md align='center'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              component='img'
              src='/assets/images/circle-support.png'
              sx= {{ width: '40%' }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography align='center' color='primary' variant='h6' gutterBottom>
              <b style={{ fontWeight: 900 }}>Apoyo</b>
            </Typography>
            <Typography align='center' variant='body1' gutterBottom>
              Light Spot busca ayudar a una nueva generación de preceptores y facilitar el seguimiento a los más experimentados.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md align='center'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              component='img'
              src='/assets/images/circle-skills.png'
              sx= {{ width: '40%' }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography align='center' color='primary' variant='h6' gutterBottom>
              <b style={{ fontWeight: 900 }}>Agilidad</b>
            </Typography>
            <Typography align='center' variant='body1' gutterBottom>
              Ayuda al preceptor a mantener toda la información en un solo lugar, de manera segura, ordenada y fácil de usar.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md align='center'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              component='img'
              src='/assets/images/circle-creativity.png'
              sx= {{ width: '40%' }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography align='center' color='primary' variant='h6' gutterBottom>
              <b style={{ fontWeight: 900 }}>Creatividad</b>
            </Typography>
            <Typography align='center' variant='body1' gutterBottom>
              Diseñada para que todos (adultos y niños) puedan aprovecharla, con una experiencia de usuario intuitiva y amistosa.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md align='center'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              component='img'
              src='/assets/images/circle-communication.png'
              sx= {{ width: '40%' }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography align='center' color='primary' variant='h6' gutterBottom>
              <b style={{ fontWeight: 900 }}>Comunicación</b>
            </Typography>
            <Typography align='center' variant='body1' gutterBottom>
              Comunicación más práctica, más inteligente y más directa entre   preceptores, padres y alumnos.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default LandingWhy